import { motion } from 'framer-motion';

export const HomeSection = () => {
  return (
    <section
      id="home"
      className="min-h-screen relative flex items-center justify-center px-4 md:px-8 pt-24 md:pt-28"
      data-testid="home-section"
    >
      <div className="max-w-5xl mx-auto text-center w-full">
        {/* Eyebrow label */}
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-white/80 text-xs sm:text-sm tracking-[0.3em] uppercase mb-6 drop-shadow"
        >
          Clean · Safe · Sustainable
        </motion.p>

        {/* Main heading */}
        <motion.h1
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="text-white font-medium leading-[0.9] tracking-tight drop-shadow-2xl text-4xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl"
        >
          Clean Spaces.<br />
          <span className="text-[#87CEEB]">Healthy Lives.</span><br />
          <span className="font-serif italic text-white">Better Future.</span>
        </motion.h1>

        {/* Description */}
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="text-white/90 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mt-8 drop-shadow-md leading-relaxed"
          data-testid="home-description"
        >
          We believe hygiene is not a luxury — it is a basic human necessity. From awareness campaigns to affordable solutions, we're building a healthier India, one space at a time.
        </motion.p>

        {/* CTAs */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3.5 bg-[#87CEEB] text-white rounded-full text-sm font-semibold hover:bg-[#6BB6D9] transition-all shadow-xl"
            data-testid="explore-btn"
          >
            Explore Our Range
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3.5 bg-white/15 backdrop-blur-md border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/25 transition-all"
            data-testid="contact-btn"
          >
            Get in Touch
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};
